import { SummaryState } from "redux/summary/summary";
import { AssetClass } from "types/AssetClass";

export const getKeyValuesData = (
  summaryData: SummaryState,
  assetClass: AssetClass
) => {
  switch (assetClass) {
    case AssetClass.Cash:
      return summaryData.Cash?.data?.find((x) => x.Paino === 100);

    case AssetClass.Commodity:
      return summaryData.Commodity?.data?.find((x) => x.Paino === 100);

    case AssetClass.Currency:
      return summaryData.Currency?.data?.find((x) => x.Paino === 100);

    case AssetClass.DirectInvestments:
      return summaryData.DirectInvestments?.data?.find((x) => x.Paino === 100);

    case AssetClass.Equity:
      return summaryData.Equity?.data?.find((x) => x.Paino === 100);

    case AssetClass.FixedIncome:
      return summaryData.FixedIncome?.data?.find((x) => x.Paino === 100);

    case AssetClass.MixedAllocation:
      return summaryData.MixedAllocation?.data?.find((x) => x.Paino === 100);

    case AssetClass.PrivateDebt:
      return summaryData.PrivateDebt?.data?.find((x) => x.Paino === 100);

    case AssetClass.PrivateEquity:
      return summaryData.PrivateEquity?.data?.find((x) => x.Paino === 100);

    case AssetClass.RealEstate:
      return summaryData.RealEstate?.data?.find((x) => x.Paino === 100);

    case AssetClass.Structured:
      return summaryData.Structured?.data?.find((x) => x.Paino === 100);

    default:
      return undefined;
  }
};
